import "core-js/modules/es.array.push.js";
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-15ba2960"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "account-container"
};
const _hoisted_2 = {
  class: "add-account"
};
const _hoisted_3 = {
  class: "pagination-box"
};
const _hoisted_4 = {
  class: "pagination-box"
};
const _hoisted_5 = {
  class: "dialog-footer"
};
const _hoisted_6 = {
  class: "search-box"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "warn"
}, [/*#__PURE__*/_createTextVNode(" 请到 "), /*#__PURE__*/_createElementVNode("span", null, "租户管理"), /*#__PURE__*/_createTextVNode(" 找到需要的租户,点击"), /*#__PURE__*/_createElementVNode("span", null, "查看子诊所"), /*#__PURE__*/_createTextVNode(",找到子诊所的对应的 "), /*#__PURE__*/_createElementVNode("span", null, "诊所id"), /*#__PURE__*/_createTextVNode("列 ")], -1));
const _hoisted_8 = {
  key: 0
};
const _hoisted_9 = {
  class: "action-box"
};
import { getAllAccountData, delAccount, addAccount, refreshAccessToken, accountUpdateBatch, updateAccountStatus } from '@/api/account';
import { getTenantInfoByClinicId } from '@/api/tenant';
import store from '@/store';
import { ElMessageBox, ElMessage } from 'element-plus';
import { computed, ref, watch } from 'vue';
import { useRouter } from 'vue-router';
export default {
  __name: 'index',
  setup(__props) {
    // import { addAccount, getallAccountData, delAccount } from '@/api/tenant'
    const router = useRouter();
    // 数据相关
    const allAccountData = ref([]);

    // const tabsArr = [
    //   {
    //     title: '正常',
    //     value: 1000
    //   },
    //   {
    //     title: '失效',
    //     value: 1100
    //   }
    // ]

    const total = ref(0);
    const currentPage = ref(1);
    const pageSize = ref(8);
    const status = ref(1000);
    const loading = ref(false);
    const getAllAccount = async () => {
      loading.value = true;
      const res = await getAllAccountData({
        currentPage: currentPage.value,
        pageSize: pageSize.value,
        status: status.value
      });
      allAccountData.value = res.records;
      total.value = res.total;
      loading.value = false;
    };
    getAllAccount();

    /**
     * tab切换
     */
    const onTabChangeHandler = () => {
      allAccountData.value = [];
      getAllAccount();
    };
    const handleCurrentChange = async val => {
      currentPage.value = val;
      await getAllAccount();
    };
    const searchDetail = row => {
      router.push(`/operation/account/detail/${row.id}`);
    };
    const dialogTenantVisible = ref(false);
    const ruleFormRef = ref(null);
    const menuArr = [{
      title: '3我的会员卡',
      value: '3'
    }, {
      title: '4消费记录',
      value: '4'
    }, {
      title: '6个人病历',
      value: '6'
    }, {
      title: '7预约中心',
      value: '7'
    }, {
      title: '8在线预约',
      value: '8'
    }];
    const form = ref({
      name: '',
      appId: '',
      appSecret: '',
      originalId: '',
      welcome: '',
      auto: '',
      service: '',
      menu: [],
      exitService: '',
      status: true
    });
    const formRule = ref({
      name: [{
        required: true,
        message: '租户名未填写',
        trigger: 'blur'
      }],
      appId: [{
        required: true,
        message: 'appId未填写',
        trigger: 'blur'
      }],
      appSecret: [{
        required: true,
        message: 'appSecret未填写',
        trigger: 'blur'
      }],
      originalId: [{
        required: true,
        message: 'originalId未填写',
        trigger: 'blur'
      }],
      auto: [{
        required: true,
        message: '留言自动回复词未填写',
        trigger: 'blur'
      }],
      service: [{
        required: true,
        message: '转人工关键字未填写',
        trigger: 'blur'
      }]
    });
    const type = ref('新增');
    const addAccountHandler = () => {
      dialogTenantVisible.value = true;
      type.value = '新增';
    };
    const submitHandler = async () => {
      if (chatType.value === 0) {
        form.value.service = '';
        form.value.exitService = '';
      } else if (chatType.value === 2) {
        form.value.auto = '';
        form.value.service = '';
        form.value.exitService = '';
      }
      try {
        await ruleFormRef.value.validate();
        await addAccount({
          ...form.value,
          menu: form.value.menu.join(';'),
          status: form.value.status ? 1000 : 1100
        });
        await getAllAccount();
        dialogTenantVisible.value = false;
        ElMessage({
          message: `${type.value}成功`,
          type: 'success'
        });
      } catch (error) {
        ElMessage({
          message: `${type.value}失败`,
          type: 'warning'
        });
      }
    };
    const resetForm = () => {
      var _ruleFormRef$value;
      (_ruleFormRef$value = ruleFormRef.value) === null || _ruleFormRef$value === void 0 || _ruleFormRef$value.resetFields();
      form.value = {
        name: '',
        appId: '',
        appSecret: '',
        originalId: '',
        welcome: '',
        auto: '',
        service: '',
        exitService: '',
        status: true
      };
    };
    watch(dialogTenantVisible, val => {
      if (!val) {
        resetForm();
      }
    });
    const delAccountHandler = async row => {
      try {
        await ElMessageBox.confirm('确认删除吗', '温馨提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        });

        // 如果该租户的子诊所数量为0的话
        await delAccount(row.id);
        await getAllAccount();
        ElMessage({
          message: '删除成功',
          type: 'success'
        });
      } catch (error) {
        console.log(`error${error}`);
      }
    };
    const editAccountHandler = async row => {
      type.value = '修改';
      dialogTenantVisible.value = true;
      // form.value = { ...row, isChain: Boolean(row.isChain) }
      if (row.auto && row.service && row.exitService) {
        chatType.value = 1;
      }
      if (!row.auto && !row.service && !row.exitService) {
        chatType.value = 2;
      }
      if (row.auto && !row.service && !row.exitService) {
        chatType.value = 0;
      }
      form.value = {
        ...row,
        menu: row.menu.split(';'),
        status: row.status === 1000
      };
    };

    /**
     * 批量刷新公众号
     */
    const isUpdateBatchAccountVisible = ref(false);
    const currentAccountId = ref('');
    const clinicId = ref('');
    const accountUpdateBatchHandler = async row => {
      currentAccountId.value = row.id;
      isUpdateBatchAccountVisible.value = true;
    };
    const isInspected = ref(false);
    const tenantInfo = ref(null);
    const isParent = ref(false);
    const onInspectTenantHandler = async () => {
      if (!clinicId.value) {
        ElMessage.warning('请填入诊所id');
        return;
      }
      try {
        const res = await getTenantInfoByClinicId(clinicId.value);
        tenantInfo.value = res;
        isInspected.value = true;
        if (res.isParent === 1) {
          isParent.value = true;
        }
      } catch (error) {}

      // isInspected.value
    };
    const accountUpdateBatchConfirm = async () => {
      if (!clinicId.value) {
        ElMessage.warning('请填入诊所id');
        return;
      }
      if (!isInspected.value) {
        ElMessage.warning('请先校验该诊所id');
        return;
      }
      if (isParent.value) {
        ElMessage.warning('父节点不可配置');
        return;
      }
      try {
        await ElMessageBox.confirm('是否要批量刷新该公众号', '温馨提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        });
        // console.log(row)
        await accountUpdateBatch(currentAccountId.value, clinicId.value);
        ElMessage({
          message: '刷新成功',
          type: 'success'
        });
        isUpdateBatchAccountVisible.value = false;
        await getAllAccount();
      } catch (error) {}
    };
    const onBatchAccountClose = () => {
      currentAccountId.value = '';
      clinicId.value = '';
      isInspected.value = false;
      tenantInfo.value = null;
      isParent.value = false;
    };

    /**
     * 改变公众号状态
     */
    const updateStatusHandler = async row => {
      try {
        await ElMessageBox.confirm('是否改变该公众号状态', '温馨提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        });
        // console.log(row)
        await updateAccountStatus({
          id: row.id,
          status: 1000
        });
        ElMessage({
          message: '更改成功',
          type: 'success'
        });
        await getAllAccount();
      } catch (error) {}
    };

    /**
     * 跳转自动回复管理页面
     */
    const jumpGreetingHandler = raw => {
      router.push(`/operation/account/messageManage/${raw.id}/${raw.path}/${raw.name}`);
    };

    /**
     * 跳转菜单管理
     */
    const jumpMenuHandler = row => {
      router.push(`/operation/account/menuManage/${row.id}/${row.path}/${row.name}`);
    };
    const jumpTemplateHandler = row => {
      router.push(`/operation/account/templateManage/${row.id}/${row.path}/${row.name}`);
    };

    /**
     * 上传相关
     */
    const fileList = ref([]);
    const headers = computed(() => {
      return {
        Authorization: 'Bearer ' + store.getters.token
      };
    });

    // const changeFiles = (file, fileList) => {
    //   console.log('file', file, fileList)
    //   if (file.type !== 'text/plain') {
    //     ElMessage.error('只能上传text格式的文件') // 限制文件类型
    //     return false
    //   } else {
    //     const param = new FormData()
    //     param.append('file', file)
    //     console.log(param)
    //   }
    // }

    const onUploadSuccessHandler = response => {
      ElMessage.success('上传成功');
    };
    const onUploadErrorHandler = error => {
      console.log('error', error);
      ElMessage.success('上传成功');
    };
    const onBeforeFileUploadHandler = rawFile => {
      if (rawFile.type !== 'text/plain') {
        ElMessage.error('只能上传text格式的文件');
        return false;
      } else if (rawFile.size / 1024 / 1024 > 2) {
        ElMessage.error('上传文件大小限制为2k');
        return false;
      }
      return true;
    };
    const onUpdateAccountHandler = async row => {
      try {
        await refreshAccessToken(row.path);
        ElMessage.success('刷新成功');
      } catch (error) {
        console.log('error', error);
      }
    };

    /**
     * 留言类型 chatType
     */
    const chatTypeArr = [{
      label: '纯自动回复',
      value: 0
    }, {
      label: '自动转人工回复',
      value: 1
    }, {
      label: '纯人工回复',
      value: 2
    }];
    const chatType = ref(0);
    const onRadioChange = e => {
      chatType.value = e;
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_upload = _resolveComponent("el-upload");
      const _component_el_card = _resolveComponent("el-card");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_el_checkbox_button = _resolveComponent("el-checkbox-button");
      const _component_el_checkbox_group = _resolveComponent("el-checkbox-group");
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_permission = _resolveDirective("permission");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_card, {
        class: "title-card",
        shadow: "never"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_upload, {
          "file-list": fileList.value,
          class: "upload-demo",
          action: "/api/yia/v1/account/upload",
          limit: 1,
          headers: headers.value,
          accept: ".txt",
          "show-file-list": false,
          "on-success": onUploadSuccessHandler,
          "on-error": onUploadErrorHandler,
          "before-upload": onBeforeFileUploadHandler
        }, {
          default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
            type: "primary",
            style: {
              "margin-right": "20px"
            }
          }, {
            default: _withCtx(() => [_createTextVNode(" 上传验证文件 ")]),
            _: 1
          })), [[_directive_permission, ['accountFileUpload']]])]),
          _: 1
        }, 8, ["file-list", "headers"]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          onClick: addAccountHandler
        }, {
          default: _withCtx(() => [_createTextVNode(" 新增 ")]),
          _: 1
        })), [[_directive_permission, ['accountAdd']]])])]),
        _: 1
      }), _createVNode(_component_el_card, {
        shadow: "never"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_tabs, {
          onTabChange: onTabChangeHandler,
          type: "card",
          modelValue: status.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => status.value = $event)
        }, {
          default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
            label: "启用",
            name: 1000
          }, {
            default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
              border: true,
              data: allAccountData.value,
              style: {
                "width": "100%"
              },
              "row-key": "id"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_table_column, {
                label: "公众号id",
                width: "100",
                align: "center",
                prop: "id"
              }), _createVNode(_component_el_table_column, {
                label: "刷新token",
                width: "100",
                align: "center"
              }, {
                default: _withCtx(({
                  row
                }) => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
                  type: "primary",
                  onClick: $event => onUpdateAccountHandler(row),
                  size: "small"
                }, {
                  default: _withCtx(() => [_createTextVNode(" 刷新 ")]),
                  _: 2
                }, 1032, ["onClick"])), [[_directive_permission, ['tokenRefresh']]])]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                prop: "name",
                label: "公众号名称",
                width: "250"
              }), _createVNode(_component_el_table_column, {
                prop: "appId",
                label: "appid"
              }), _createVNode(_component_el_table_column, {
                prop: "originalId",
                label: "原始id"
              }), _createVNode(_component_el_table_column, {
                fixed: "right",
                label: "操作",
                width: "520"
              }, {
                default: _withCtx(({
                  row
                }) => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
                  type: "success",
                  size: "small",
                  onClick: $event => searchDetail(row)
                }, {
                  default: _withCtx(() => [_createTextVNode(" 详情 ")]),
                  _: 2
                }, 1032, ["onClick"])), [[_directive_permission, ['accountInfo']]]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                  type: "primary",
                  size: "small",
                  onClick: $event => editAccountHandler(row)
                }, {
                  default: _withCtx(() => [_createTextVNode(" 修改 ")]),
                  _: 2
                }, 1032, ["onClick"])), [[_directive_permission, ['accountUpdate']]]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                  type: "danger",
                  size: "small",
                  onClick: $event => delAccountHandler(row)
                }, {
                  default: _withCtx(() => [_createTextVNode(" 删除 ")]),
                  _: 2
                }, 1032, ["onClick"])), [[_directive_permission, ['accountDelete']]]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                  type: "warning",
                  size: "small",
                  onClick: $event => jumpGreetingHandler(row)
                }, {
                  default: _withCtx(() => [_createTextVNode(" 回复消息管理 ")]),
                  _: 2
                }, 1032, ["onClick"])), [[_directive_permission, ['accountGreet']]]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                  color: "#626aef",
                  size: "small",
                  onClick: $event => jumpMenuHandler(row)
                }, {
                  default: _withCtx(() => [_createTextVNode(" 菜单管理 ")]),
                  _: 2
                }, 1032, ["onClick"])), [[_directive_permission, ['accountMenuManage']]]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                  color: "purple",
                  size: "small",
                  onClick: $event => jumpTemplateHandler(row)
                }, {
                  default: _withCtx(() => [_createTextVNode(" 模板消息处理 ")]),
                  _: 2
                }, 1032, ["onClick"])), [[_directive_permission, ['accountTemplateManage']]])]),
                _: 1
              })]),
              _: 1
            }, 8, ["data"])), [[_directive_loading, loading.value]]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_pagination, {
              class: "pagination",
              onCurrentChange: handleCurrentChange,
              "current-page": currentPage.value,
              "page-size": pageSize.value,
              total: total.value,
              layout: "total,  prev, pager, next, jumper"
            }, null, 8, ["current-page", "page-size", "total"])])]),
            _: 1
          }), _createVNode(_component_el_tab_pane, {
            label: "未启用",
            name: 1100
          }, {
            default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
              border: true,
              data: allAccountData.value,
              style: {
                "width": "100%"
              },
              "row-key": "id"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_table_column, {
                label: "公众号id",
                width: "100",
                align: "center",
                prop: "id"
              }), _createVNode(_component_el_table_column, {
                prop: "name",
                label: "公众号名称",
                width: "250"
              }), _createVNode(_component_el_table_column, {
                prop: "appId",
                label: "appid"
              }), _createVNode(_component_el_table_column, {
                prop: "originalId",
                label: "原始id"
              }), _createVNode(_component_el_table_column, {
                fixed: "right",
                label: "操作"
              }, {
                default: _withCtx(({
                  row
                }) => [_createVNode(_component_el_button, {
                  type: "success",
                  size: "small",
                  onClick: $event => searchDetail(row)
                }, {
                  default: _withCtx(() => [_createTextVNode(" 详情 ")]),
                  _: 2
                }, 1032, ["onClick"]), _createVNode(_component_el_button, {
                  type: "danger",
                  size: "small",
                  onClick: $event => delAccountHandler(row),
                  color: "purple"
                }, {
                  default: _withCtx(() => [_createTextVNode(" 删除 ")]),
                  _: 2
                }, 1032, ["onClick"]), !row.isRepair ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "danger",
                  size: "small",
                  onClick: $event => accountUpdateBatchHandler(row),
                  color: "#626aef"
                }, {
                  default: _withCtx(() => [_createTextVNode(" 批次更新 ")]),
                  _: 2
                }, 1032, ["onClick"])) : _createCommentVNode("", true), row.isRepair ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 1,
                  type: "danger",
                  size: "small",
                  onClick: $event => updateStatusHandler(row)
                }, {
                  default: _withCtx(() => [_createTextVNode(" 启用 ")]),
                  _: 2
                }, 1032, ["onClick"])) : _createCommentVNode("", true)]),
                _: 1
              })]),
              _: 1
            }, 8, ["data"])), [[_directive_loading, loading.value]]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_pagination, {
              class: "pagination",
              onCurrentChange: handleCurrentChange,
              "current-page": currentPage.value,
              "page-size": pageSize.value,
              total: total.value,
              layout: "total,  prev, pager, next, jumper"
            }, null, 8, ["current-page", "page-size", "total"])])]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_dialog, {
        modelValue: dialogTenantVisible.value,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => dialogTenantVisible.value = $event),
        title: "操作",
        "destroy-on-close": "",
        "close-on-click-modal": false
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_5, [_createVNode(_component_el_button, {
          onClick: _cache[11] || (_cache[11] = $event => dialogTenantVisible.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode(" 取消 ")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: submitHandler
        }, {
          default: _withCtx(() => [_createTextVNode(" 确认 ")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          "label-width": "150px",
          rules: formRule.value,
          "status-icon": "",
          model: form.value,
          ref_key: "ruleFormRef",
          ref: ruleFormRef
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "公众号名称",
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.name = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "appid",
            prop: "appId"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              type: "text",
              modelValue: form.value.appId,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.appId = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "appSecret",
            prop: "appSecret"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.appSecret,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.value.appSecret = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "originalId",
            prop: "originalId"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.originalId,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.value.originalId = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "是否正常",
            style: {
              "display": "flex",
              "align-item": "center"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_switch, {
              modelValue: form.value.status,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => form.value.status = $event),
              style: {
                "display": "flex",
                "align-items": "center"
              }
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "个人中心菜单选项"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_checkbox_group, {
              modelValue: form.value.menu,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => form.value.menu = $event)
            }, {
              default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(menuArr, item => {
                return _createVNode(_component_el_checkbox_button, {
                  key: item.value,
                  label: item.value
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(item.title), 1)]),
                  _: 2
                }, 1032, ["label"]);
              }), 64))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "留言自动回复词"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio_group, {
              modelValue: chatType.value,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => chatType.value = $event),
              onChange: onRadioChange
            }, {
              default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(chatTypeArr, item => {
                return _createVNode(_component_el_radio, {
                  key: item.value,
                  label: item.value,
                  border: ""
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(item.label), 1)]),
                  _: 2
                }, 1032, ["label"]);
              }), 64))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), chatType.value === 0 || chatType.value === 1 ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0,
            label: "留言自动回复词",
            prop: "auto"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              type: "textarea",
              autosize: "",
              modelValue: form.value.auto,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => form.value.auto = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          })) : _createCommentVNode("", true), chatType.value === 1 ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 1,
            label: "转人工关键字",
            prop: "service"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              type: "text",
              modelValue: form.value.service,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => form.value.service = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          })) : _createCommentVNode("", true), chatType.value === 1 ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 2,
            label: "离开人工回复关键字",
            prop: "exitService"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              type: "text",
              modelValue: form.value.exitService,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => form.value.exitService = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["rules", "model"])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        modelValue: isUpdateBatchAccountVisible.value,
        "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => isUpdateBatchAccountVisible.value = $event),
        onClosed: onBatchAccountClose,
        "close-on-click-modal": false
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_9, [_createVNode(_component_el_button, {
          onClick: _cache[14] || (_cache[14] = $event => isUpdateBatchAccountVisible.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode(" 取消 ")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: accountUpdateBatchConfirm
        }, {
          default: _withCtx(() => [_createTextVNode(" 确认 ")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createVNode(_component_el_input, {
          modelValue: clinicId.value,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => clinicId.value = $event),
          placeholder: "请填入诊 所id"
        }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
          type: "primary",
          onClick: onInspectTenantHandler
        }, {
          default: _withCtx(() => [_createTextVNode(" 检验 ")]),
          _: 1
        })]), _hoisted_7, tenantInfo.value ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(tenantInfo.value.name + '-' + tenantInfo.value.description), 1)) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
};